// extracted by mini-css-extract-plugin
module.exports = {"component":"Ellipses-component--oOS1a"};